__turbopack_context__.v({
  "bg": "SubCategoryCard-module-scss-module__4EzxPa__bg",
  "card-wrapper": "SubCategoryCard-module-scss-module__4EzxPa__card-wrapper",
  "sub-category-card": "SubCategoryCard-module-scss-module__4EzxPa__sub-category-card",
});
